<template>
  <div style="width: 100%">
    <el-table
      @select-all="handleSelectAll"
      @select="handleSelect"
      v-loading="loading"
      :tree-props="treeProps ? treeProps : ''"
      row-key="id"
      :data="list"
      style="width: 100%"
      stripe
      ref="multipleTable"
    >
      <el-table-column
        v-if="selection"
        type="selection"
        algin="center"
        width="50"
        reserve-selection
      >
      </el-table-column>
      <el-table-column
        v-for="(item, index) in tableList"
        :align="item.align || 'center'"
        :key="index"
        :width="item.width"
        v-bind="item"
      >
        <template #default="scope">
          <slot :name="item.prop" :row="scope.row">
            {{
              scope.row[item.prop]
                ? scope.row[item.prop]
                : item.label
                ? "-"
                : ""
            }}
          </slot>
        </template>
      </el-table-column>
    </el-table>
    <div
      v-if="total > pagesize"
      :style="{ textAlign: pageAlign, padding: pagePadding }"
    >
      <el-pagination
        background
        :hide-on-single-page="true"
        @current-change="changepage"
        :current-page="page"
        :page-size="pagesize"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { eltips } from "@/util/util.js";
export default {
  name: "baseTable",
  props: {
    treeProps: {
      type: Object,
      default: () => {
        return {
          children: "children",
          hasChildren: "hasChildren",
        };
      },
    },
    selection: {
      type: Boolean,
      default: false,
    },
    tableList: {
      type: Array,
      default: [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: [],
    },
    total: {
      type: Number,
      default: 0,
    },
    page: {
      type: Number,
      default: 1,
    },
    pagesize: {
      type: Number,
      default: 10,
    },
    pageAlign: {
      type: String,
      default: "center",
    },
    pagePadding: {
      type: String,
      default: "20px 0",
    },
  },
  data() {
    return {
      // 存储结构：{ 页码: Set(选中ID) }
      selectedIds: [], // 存储选中行的 id
      allIds: [], // 存储选中行的 id
      currentSelections: [], // 当前页选中数据
    };
  },
  watch: {
    list: {
      handler() {
        this.$nextTick(() => {
          this.restoreSelections();
        });
      },
    },
  },
  created() {},
  methods: {
    updateSelectedMap(data) {
      this.selectedIds = data.map((item) => {
        return Number(item.id);
      });
      this.allIds = this.selectedIds;
      this.$refs.multipleTable.clearSelection(); // 清除所有选中的行
      this.restoreSelections();
    },
    // 恢复当前页的选中状态
    restoreSelections() {
      console.log('=====我是执行=====')
      // 根据存储的选中 id 数组勾选表格中的行
      this.$nextTick(() => {
        this.list.forEach((row) => {
          if (this.allIds.includes(row.id)) {
            this.$refs.multipleTable.toggleRowSelection(row, true);
          }
        });
      });
    },
    changepage(e) {
      this.allIds.push(...this.selectedIds);
      this.allIds = [...new Set(this.allIds)];
      this.$emit("changePage", e);
    },
    // 处理单选
    handleSelect(selection, row) {
      if (selection.includes(row)) {
        // 新增选中
        if (!this.selectedIds.includes(row.id)) {
          this.selectedIds.push(row.id);
        }
      } else {
        // 取消选中
        const index = this.selectedIds.indexOf(row.id);
        if (index > -1) {
          this.selectedIds.splice(index, 1);
        }
      }
      this.$emit("tableSelectionChange", selection);
    },

    // 处理全选
    handleSelectAll(selection) {
      if (selection.length === 0) {
        // 取消全选：移除当前页所有ID
        this.list.forEach((row) => {
          const index = this.selectedIds.indexOf(row.id);
          if (index > -1) this.selectedIds.splice(index, 1);
        });
        this.selectedIds = this.selectedIds.filter(
          (item2) => !selection.some((item1) => item1.id === item2.id)
        );
        // this.allIds = this.allIds.filter(
        //   (item2) => !selection.some((item1) => item1.id === item2.id)
        // );
        console.log("我进入了取消全选方法", this.selectedIds);
      } else {
        // 全选当前页：添加当前页所有ID（去重）
        this.list.forEach((row) => {
          if (!this.selectedIds.includes(row.id)) {
            this.selectedIds.push(row.id);
          }
        });
        this.allIds.push(...this.selectedIds);
        this.allIds = [...new Set(this.allIds)];
      }

      // this.$refs.multipleTable.toggleAllSelection();
      console.log("我是当前选中的值", this.selectedIds, "-------", this.allIds);
    },
    getAllSelections() {
      console.log("我在测试全选的时候", this.allIds);
      return this.allIds.filter(item=>item!=undefined);
    },
  },
};
</script>

<style lang="scss" scoped></style>
